/**
 * Provider/inverter brand badge: colored dot + label. Use wherever provider_type is displayed.
 * Colors from design tokens (--provider-*).
 */
const PROVIDER_COLORS: Record<string, string> = {
  solark: 'var(--provider-solark)',
  eg4: 'var(--provider-eg4)',
  solaredge: 'var(--provider-solaredge)',
  franklin: 'var(--provider-franklin)',
  franklinwh: 'var(--provider-franklin)',
  tesla: 'var(--provider-tesla)',
  emporia: 'var(--provider-emporia)',
  victron: 'var(--provider-victron)',
  solis: 'var(--provider-solis)',
};

const PROVIDER_LABELS: Record<string, string> = {
  solark: 'Sol-Ark',
  eg4: 'EG4',
  solaredge: 'SolarEdge',
  franklin: 'Franklin',
  franklinwh: 'FranklinWH',
  tesla: 'Tesla',
  emporia: 'Emporia',
  victron: 'Victron',
  enphase: 'Enphase',
  solis: 'Solis',
  manual: 'Manual',
};

export function ProviderBadge({ provider }: { provider: string }) {
  const key = provider.toLowerCase().replace(/[-_\s]/g, '');
  const color = PROVIDER_COLORS[key] ?? 'var(--provider-default)';
  const label = PROVIDER_LABELS[key] ?? provider;

  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide"
      style={{ color }}
    >
      <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: color }} />
      {label}
    </span>
  );
}
